'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:NotificationServiceCtrl
 * @description
 * # NotificationCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('Notification', ['$http', 'domain', 'BaseService', '$window', 'User', '$rootScope', function ($http, domain, BaseService, $window, User, $rootScope) {
    var BASE_NOTIFICATION_URL = domain.name + '/api/v1/notifications/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_NOTIFICATION_URL,
      baseModelName: 'notification'
    });

    baseService.sendNotification = function(newMessage) {
      var notificationData = {
        notification: {
          message: newMessage.message,
          author_name: newMessage.user.name
        }
      };
      return $http.post(BASE_NOTIFICATION_URL, notificationData);
    };

    baseService.InitNotification = function(firebase) {
      var config = {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT_ID,
        storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.FIREBASE_APP_ID,
        measurementId: process.env.FIREBASE_MEASUREMENT_ID
      };

      firebase.apps.length ? firebase.app() : firebase.initializeApp(config);
      $rootScope.firebase = firebase;

      if ('currentUser' in $window.localStorage && 'serviceWorker' in navigator) {
        const currentUser = JSON.parse($window.localStorage.currentUser);

        navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then(function(registration) {
            const messaging = firebase.messaging();
            messaging.useServiceWorker(registration);

            messaging.onMessage(function(payload) {
              const notificationTitle = payload.notification.title;
              const notificationOptions = {
                body: payload.notification.body,
                icon: payload.notification.icon,
                data: { url: payload.notification.click_action }
              };

              navigator.serviceWorker.ready.then(function(registration) {
                registration.showNotification(notificationTitle, notificationOptions);
              });

              navigator.serviceWorker.addEventListener('notificationclick', function(event) {
                event.notification.close();
                const urlToOpen = new URL(event.notification.notification.click_action, self.location.origin).href;

                event.waitUntil(
                  clients.matchAll({ type: 'window', includeUncontrolled: true }).then(windowClients => {
                    for (let client of windowClients) {
                      if (client.url.includes(self.location.origin) && 'focus' in client) {
                        client.navigate(urlToOpen);
                        return client.focus();
                      }
                    }
                    if (clients.openWindow) {
                      return clients.openWindow(urlToOpen);
                    }
                  })
                );
              });
            });

            firebase.auth().onAuthStateChanged(function(user) {
              if (!user) return;
              messaging.getToken({
                vapidKey: process.env.FIREBASE_VAPIDKEY
              }).then(function(token) {
                const params = {
                  token: token,
                  google_id: currentUser.sub
                };
                User.save_cloud_token(params);
              }).catch(function(err) {
                console.error("No se pudo obtener el token de notificación:", err);
              });
            });
          }).catch(function(error) {
            console.error('Error registrando el Service Worker:', error);
          });
      }
    };

    return baseService;
  }]);
